/**
 * Login action
 */
export const LOGIN = "LOGIN";
export type LOGIN = typeof LOGIN;

/**
 * Logout action
 */
export const LOGOUT = "LOGOUT";
export type LOGOUT = typeof LOGOUT;

/**
 * Set selected exhibition action
 */
export const SET_SELECTED_EXHIBITION = "SET_SELECTED_EXHIBITION";
export type SET_SELECTED_EXHIBITION = typeof SET_SELECTED_EXHIBITION;

/**
 * Set exhibitions action
 */
export const SET_EXHIBITIONS = "SET_EXHIBITIONS";
export type SET_EXHIBITIONS = typeof SET_EXHIBITIONS;

/**
 * Set devices action
 */
export const SET_DEVICES = "SET_DEVICES";
export type SET_DEVICES = typeof SET_DEVICES;

/**
 * Set group content versions action
 */
export const SET_SELECTED_GROUP_CONTENT_VERSIONS = "SET_SELECTED_GROUP_CONTENT_VERSIONS";
export type SET_SELECTED_GROUP_CONTENT_VERSIONS = typeof SET_SELECTED_GROUP_CONTENT_VERSIONS;

/**
 * Set device groups action
 */
export const SET_DEVICE_GROUPS = "SET_DEVICE_GROUPS";
export type SET_DEVICE_GROUPS = typeof SET_DEVICE_GROUPS;

/**
 * Set device models action
 */
export const SET_DEVICE_MODELS = "SET_DEVICE_MODELS";
export type SET_DEVICE_MODELS = typeof SET_DEVICE_MODELS;

/**
 * Set layouts action
 */
export const SET_LAYOUTS = "SET_LAYOUTS";
export type SET_LAYOUTS = typeof SET_LAYOUTS;

/**
 * Set selected layout action
 */
export const SET_SELECTED_LAYOUT = "SET_SELECTED_LAYOUT";
export type SET_SELECTED_LAYOUT = typeof SET_SELECTED_LAYOUT;

/**
 * Set sub layouts action
 */
export const SET_SUB_LAYOUTS = "SET_SUB_LAYOUTS";
export type SET_SUB_LAYOUTS = typeof SET_SUB_LAYOUTS;

/**
 * Set selected sub layout action
 */
export const SET_SELECTED_SUB_LAYOUT = "SET_SELECTED_SUB_LAYOUT";
export type SET_SELECTED_SUB_LAYOUT = typeof SET_SELECTED_SUB_LAYOUT;